import React from "react"
import { injectIntl } from "react-intl"
import BaseStatBox from "../../../common/statbox/BaseStatBox"
import IntlProps from "../../../state/helpers/IntlProps"
import { messages } from "./messages"

type OwnProps = {
    amount: number
    currency: string
}

const StatBoxBalance = (props: OwnProps & IntlProps) => {

    return (
        <BaseStatBox
            title={props.intl.formatMessage(messages["balanceTitle"])}
            amount={props.amount}
            currency={props.currency}
            displayTooltip={true}
            tooltipMessage={props.intl.formatMessage(messages["balanceTooltipMessage"])}
            notes={props.intl.formatMessage(messages["estimatedAmounts"])}
        />
    )
}

export default injectIntl(StatBoxBalance)



// WEBPACK FOOTER //
// ./src/payment-processing/payout-listing/statBoxes/StatboxBalance.tsx